import PropTypes from 'prop-types';
import { useProgressBar } from 'react-aria';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './ProgressBar.module.scss';

const ProgressBar = (props) => {
    const {
        label,
        showValueLabel = !!label,
        value,
        minValue,
        maxValue
    } = props;
    const {
        progressBarProps,
        labelProps
    } = useProgressBar(props);

    const percentage = (value - minValue) / (maxValue - minValue);
    const barWidth = `${Math.round(percentage * 100)}%`;

    return (
        <div {...progressBarProps}>
            <div className={styles.label}>
                {label &&
                    (
                        <span {...labelProps}>
                            {label}
                        </span>
                    )}
                {showValueLabel &&
                    (
                        <span>
                            {progressBarProps['aria-valuetext']}
                        </span>
                    )}
            </div>
            <div className={styles.outer}>
                <div
                    className={styles.inner}
                    style={{ width: barWidth }}
                />
            </div>
        </div>
    );
};

ProgressBar.propTypes = {
    ...defaultAriaProps,
    label: PropTypes.string,
    showLabel: PropTypes.bool,
    value: PropTypes.number,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    size: PropTypes.number

};

ProgressBar.defaultProps = {
    'data-testid': 'loading',
    'aria-label': 'loading...',
    value: 0,
    minValue: 0,
    maxValue: 100,
    size: 32
};

export default ProgressBar;
